import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

const GOOGLE_ANALYTICS_ERROR_MESSAGE = 'ga';
const DASHBOARD_DOCUMENT_FRAME =
  /^(?:app:\/\/\/|https?:\/\/[^/]+\/)[^/]+\/v\/dashboard(?:[?#].*)?$/;

const isGoogleAnalyticsErrorMessage = (message: unknown): boolean =>
  toNormalizedMessage(message) === GOOGLE_ANALYTICS_ERROR_MESSAGE;

const hasOnlyDashboardDocumentFrames = (
  stackFrameFilenames: readonly string[]
): boolean =>
  stackFrameFilenames.length > 0 &&
  stackFrameFilenames.every((filename) =>
    DASHBOARD_DOCUMENT_FRAME.test(toNormalizedMessage(filename) ?? '')
  );

export const googleAnalyticsDashboardErrorRule: ClientSentryIgnoreRule = {
  id: 'google-analytics-dashboard-error',
  references: ['FTR-3342'],
  reason:
    'Known GA/GTM global onerror on the dashboard with no seller-ui source frame',
  matches: ({
    firstExceptionType,
    originalExceptionMessage,
    serializedMessage,
    stackFrameFilenames,
  }) => {
    if (firstExceptionType !== 'Error') {
      return false;
    }

    if (
      !isGoogleAnalyticsErrorMessage(serializedMessage) &&
      !isGoogleAnalyticsErrorMessage(originalExceptionMessage)
    ) {
      return false;
    }

    return hasOnlyDashboardDocumentFrames(stackFrameFilenames);
  },
};
